



























import { Component, Prop } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import VueEvent from "@/app/core/decorator/VueEvent";
import { CardMeta } from "@/@types/gameObject";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import { StoreUseData } from "@/@types/store";
import { Size } from "address";
import { createSize } from "@/app/core/utility/CoordinateUtility";

@Component
export default class CardComponent extends Mixins<ComponentVue>(ComponentVue) {
  @Prop({ type: Object, required: true })
  private cardMeta!: StoreUseData<CardMeta>;

  @Prop({ type: Object, required: true })
  private size!: Size;

  @Prop({ type: Boolean, required: true })
  private isTurnOff!: boolean;

  @VueEvent
  private get containerStyle() {
    return {
      width: `${this.size.width}px`,
      height: `${this.size.height}px`
    };
  }

  @VueEvent
  private get cardStyle() {
    const cardRawSize = createSize(
      this.cardMeta.data!.width,
      this.cardMeta.data!.height
    );
    const cardSizeRatio = Math.min(
      this.size.width / cardRawSize.width,
      this.size.height / cardRawSize.height
    );
    return {
      transform: `scale(${cardSizeRatio})`
    };
  }

  @VueEvent
  private get frontStyle() {
    const cm = this.cardMeta.data!;
    return {
      backgroundImage: cm.frontImage,
      backgroundColor: cm.frontBackgroundColor,
      color: cm.fontColor,
      padding: `${cm.padTop}px ${cm.padHorizontal}px ${cm.padBottom}px`,
      borderRadius: `${cm.radius}px`,
      width: `${cm.width}px`,
      height: `${cm.height}px`
    };
  }

  @VueEvent
  private get backStyle() {
    const cm = this.cardMeta.data!;
    return {
      backgroundImage: cm.backImage,
      backgroundColor: cm.backBackgroundColor,
      color: cm.fontColor,
      borderRadius: `${cm.radius}px`,
      width: `${cm.width}px`,
      height: `${cm.height}px`
    };
  }

  private get elm(): HTMLElement {
    return this.$refs.elm as HTMLElement;
  }
}
